import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Button, Form, FormGroup, Label, Input } from 'reactstrap'
import { Paperclip, ArrowRight } from 'phosphor-react'
import styled from 'styled-components'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import { processError } from '../../lib/lib'
const cookies = new Cookies()

const HomeworkForm = styled(Form)`
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 20px;
    flex-direction: column;
    .form-group {
        margin-bottom: 0;
    }
`

const TitleWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    .title {
        color: #2D0F19;
        font-weight: 600;
    }
    .status {
        color: #2D0F19;
        font-weight: 600;
    }
    .status-0 {
        color: #D78100;
    }
    .status--1 {
        color: #FF0000;
    }
    .status-1 {
        color: #00A743;
    }
`

const CommentInput = styled(FormGroup)`
    margin-top: 20px;
    width: 100%;
    height: 130px;
    textarea {
        width: 100%;
        height: 100%;
        resize: none;
        padding: 20px;
    }
`

const AttachButton = styled(Label)`
    background-color: #DDDDDD;
    padding: 10px 20px;
    border-radius: 5px;
    margin-bottom: 0 !important;
    span {
        color: #000000;
        padding-left: 8px;
        font-weight: 700;
    }
    &:hover {
        cursor: pointer;
    }
`

const ButtonsWrapper = styled.div`
    display: flex;
    position: absolute;
    bottom: 20px;
    right: 20px;
    button {
        margin-left: 20px;
    }
`

const FileInputButton = styled(Input)`
    position: absolute;
    z-index: -1;
    bottom: 0;
`

class FileInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            base64Files: [],
            fileSelectorPlaceholder: '',
            fileNames: [],
            comment: '',
            sendMessageAction: false,

        }
        this.fileSelectHandler = this.fileSelectHandler.bind(this)
        this.changeCommentHandler = this.changeCommentHandler.bind(this)

    }

    convertToBase64(file) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            let myReader = new FileReader()
            // eslint-disable-next-line no-unused-vars
            myReader.onloadend = (e) => {
                resolve(myReader.result)
            }
            myReader.readAsDataURL(file)
        })
    }

    changeCommentHandler(e) {
        this.setState({ comment: e.target.value })
    }

    fileSelectHandler(e) {
        const files = Object.keys(e.target.files).map((key) => e.target.files[key])
        let fileNames = []
        if (Array.isArray(files) && files.length <= 10) {
            files.map(async (file) => {
                if (file !== null && file.size <= 1e+6) {
                    const base64Files = this.state.base64Files
                    const base64File = await this.convertToBase64(file)
                    base64Files.push({ filename: file.name, content: base64File })
                    fileNames.push(file.name)
                    const fileSelectorPlaceholder = fileNames.join(', ')
                    this.setState({ base64Files, fileSelectorPlaceholder })
                } else {
                    return
                    // console.log('file size is more than 1mb')
                }
            })
        } else {
            return
            // console.log('more than 10 files')
        }
    }

    sendMessage(e) {
        e.preventDefault()
        this.setState({ sendMessageAction: true })
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const { courseId, modId, localId } = this.props
        const files = this.state.base64Files
        const comment = this.state.comment
        api.sendCourseTaskFile({ localId, token, lang, courseId, modId, files, comment })
            .then((res) => {
                if (res.success) this.props.updateHomework().then(() => this.setState({ base64Files: [], fileNames: [], fileSelectorPlaceholder: '', comment: '', sendMessageAction: false }))
            })
            .catch((e) => processError(e, this.props.history))
    }



    render() {
        const { t } = this.props
        return (
            <HomeworkForm onSubmit={(e) => this.sendMessage(e)}>
                <TitleWrapper>
                    <div className="title pt-0 lg-font-size" dangerouslySetInnerHTML={{ __html: this.props.title }}></div>
                    <div className={`status status-${this.props.status} md-font-size`}>{t(`homework-status-${this.props.status}`)}</div>
                </TitleWrapper>
                <CommentInput>
                    <Input
                        type="textarea"
                        name="comment"
                        onChange={this.changeCommentHandler}
                        value={this.state.comment}
                        // id="homework_comment"
                        placeholder={t('homework-write-comment')}
                        disabled={this.props.status === 1}
                        required
                    />
                </CommentInput>
                <ButtonsWrapper>
                    <FormGroup>
                        <AttachButton htmlFor={this.props.localId}>
                            <Paperclip size={20} color="#000000" />
                            <span className="md-font-size">{this.state.fileSelectorPlaceholder || t('homework-attach')}</span>
                        </AttachButton>
                        <FileInputButton
                            type="file"
                            name="file"
                            accept=".png, .jpg"
                            onChange={this.fileSelectHandler}
                            id={this.props.localId}
                            multiple
                            disabled={this.props.status === 1 || this.state.sendMessageAction}
                        // required
                        />
                    </FormGroup>
                    <Button
                        type="submit"
                        className="profile-avatar-btn primary mt-0 p-10-20px"
                        disabled={this.props.status === 1 || this.state.sendMessageAction}
                    >
                        <React.Fragment>
                            <ArrowRight size={20} color="#FFFFFF" />
                            <span className='md-font-size pl-8px'>{t('homework-send')}</span>
                        </React.Fragment>
                    </Button>
                </ButtonsWrapper>
            </HomeworkForm>
        )
    }
}

FileInput.propTypes = {
    t: PropTypes.func,
    i18n: PropTypes.object,
    history: PropTypes.object,
    courseId: PropTypes.string,
    modId: PropTypes.string,
    status: PropTypes.number,
    updateHomework: PropTypes.func,
    title: PropTypes.string,
    localId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
}


export default withTranslation()(FileInput)


// WEBPACK FOOTER //
// ./src/components/Study/FileInput.jsx